<template>
  <div id="app" class="container is-fluid" style="margin-left: 32px; margin-right: 32px" v-cloak>
    <b-loading v-bind:is-full-page="true" v-bind:active.sync="$store.state.isLoading"></b-loading>

    <b-message v-if="isIE" title="Internet Explorer can't run Quest correctly" type="is-danger" has-icon>
      We notice you are running Internet Explorer. Unfortunately, IE can't
      display some pages correctly.<br /><br />
      Solution: Please use Chrome, Firefox, or Safari.
    </b-message>

    <b-message v-if="isEdge" title="Microsoft Edge can't run Quest correctly" type="is-danger" has-icon>
      We notice you are running Edge. Unfortunately, Edge can't display some
      pages correctly.<br /><br />
      Solution: Please use Chrome, Firefox, or Safari.
    </b-message>

    <vue-snotify></vue-snotify>
    <Messages />

    <nav class="navbar" ref="mainMenu" :class="{ 'is-fixed-top': !$store.state.isPdf }" role="navigation"
      aria-label="main navigation" v-if="$store.state.isLoginRequired && !$store.state.isPdf"
      style="margin-left: 32px; margin-right: 32px; position: fixed; zindex: 20">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img src="@/assets/Quest-logo-plain_246x50.png" />
        </a>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarMain">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarMain" class="navbar-menu" v-if="$store.getters.session != ''">
        <div class="navbar-start">
          <div class="level">
            <section v-for="route in routes" v-bind:key="route.display">
              <div class="navbar-item" v-if="route.visible">
                <router-link :to="route.path">
                  <span :class="route.style" class="is-size-6"></span>
                  <span :id="route.component" class="is-size-6">
                    {{ route.display }}</span>
                </router-link>
              </div>
            </section>
          </div>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                <a>
                  <span class="fas fa-user" style="padding-right: 4px" />
                  <span>{{ $store.getters.session.user.firstName }}
                    {{ $store.getters.session.user.lastName }}</span>
                </a>
              </a>

              <div class="navbar-dropdown">
                <a class="navbar-item">
                  <router-link to="/settings">
                    <span class="fas fa-cog" style="padding-right: 4px" />
                    <span>Settings</span>
                  </router-link>
                </a>

                <a class="navbar-item" href="https://www.lifestylesquest.live/tutorials/" target="_blank">
                  <a><span class="fas fa-question" style="padding-right: 4px" />Help</a>
                </a>

                <hr class="navbar-divider" />

                <a class="navbar-item" @click="$store.commit('CLEAR_SESSION')">
                  <a><span class="fas fa-sign-out-alt" style="padding-right: 4px"></span>
                    <span>Sign out</span></a>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div v-if="$store.getters.session && $store.state.isLoginRequired">
      <b-message type="
      is-warning" title="Preferences Need To Be Set" :active.sync="!$store.getters.session.user.preferences.updated">
        Please set your Preferences to significantly speed up evaluations.
        <router-link to="/settings">CLICK HERE</router-link>
      </b-message>
    </div>

    <router-view />

    <div class="footer" v-if="!$store.state.isPublicListing">
      <div class="content is-small">
        <p>
          APP v4.4.2 | API v{{ $store.state.apiVersion }} | ©
          {{ new Date().getFullYear() }} Lifestyles Quest, LLC. All rights
          reserved.
        </p>
        <p>
          Use of this site and software constitutes acceptance of our
          <router-link :to="{ name: 'PrivacyPolicy' }">Privacy Policy</router-link>
          and
          <router-link :to="{ name: 'TermsAndConditions' }">Terms & Conditions</router-link>.
        </p>
        <p v-if="$store.state.isEvaluating" style="font-size: 12px">
          DISCLAIMER: This represents an estimated sale price for this property.
          It is not the same as the opinion of value in an appraisal developed
          by a licensed appraiser under the Uniform Standards of Professional
          Appraisal Practice. LS Realty Advisors, Inc., and/or Lifestyles
          Realty, Inc., and/or Lifestyles Unlimited, Inc. have not verified the
          information and make no guarantee, warranty, or representation. This
          broker price opinion was either filled out by a Lifestyles
          representative or the potential buyer or other. Further investigation
          may be necessary as more information is made available. When more
          information is available the opinion may substantially change; the
          reader should be aware of the limited scope of this opinion.
        </p>
        <div v-if="$store.state.evaluation.mlsMarket == 'FMLS'">
          <p style="font-size: 12px">
            <img src="@/assets/fmls-logo.png" width="50" />
            Information Deemed Reliable But Not Guaranteed. If you believe any FMLS listing contains material that
            infringes your copyrighted work please <a target="_blank" href="https://www.fmls.com/dmca.htm">click
              here</a> to review
            our DMCA policy and learn how to submit a takedown request. © {{ new Date().getFullYear() }} FMLS
          </p>
          <p>
            FMLS content last updated {{ $store.state.evaluation.lastUpdate | dateMedium }}
          </p>
        </div>
      </div>
    </div>

    <b-modal :active.sync="
				$store.state.isLoginRequired && $store.getters.session == ''
			" has-modal-card :canCancel="[]">
      <Login />
    </b-modal>
  </div>
</template>

<script>
document.addEventListener("DOMContentLoaded", () => {
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll(".navbar-burger"),
    0
  );
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(el => {
      el.addEventListener("click", () => {
        const target = el.dataset.target;
        const $target = document.getElementById(target);
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");
      });
    });
  }
});

import { routes } from "@/routes";
import store from "@/store";
import Login from "@/components/authentication/Login.vue";
import Messages from "@/services/Messages.vue";

export default {
  components: {
    Login,
    store,
    Messages
  },
  data() {
    return {
      routes,
      collapsed: true,
      isIE: false,
      isEdge: false,
      apiVersion: "0.0"
    };
  },
  mounted() {
    this.checkBrowser();

    // Get the API version.
    this.$store.dispatch("getVersion");

    // Display support beacon if we are not doing a PDF.
    if (!this.$store.state.isPdf && !this.$store.state.isPublicListing)
      window.Beacon("init", "0dbe1022-5023-4df3-8c21-050af0a4c82d");
  },
  methods: {
    logout() {
      store.commit("CLEAR_SESSION");
    },

    checkBrowser() {
      this.isIE = false;
      this.isEdge = false;

      var isIE =
        !!navigator.userAgent.match(/Trident/g) ||
        !!navigator.userAgent.match(/MSIE/g);
      if (isIE) this.isIE = true;

      if (navigator.appName == "Netscape") {
        if (navigator.appVersion.indexOf("Edge") > -1) this.isEdge = true;
      }
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
// $primary: #4099ff;
// $primary-invert: findColorInvert($primary);

// Setup $colors to use as bulma classes.
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
// $link: $primary;
// $link-invert: $primary-invert;
// $link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<style>
.moveable-card {
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0px;
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.moveable-card::after {
  content: "";
  border-radius: 5px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  opacity: 0;
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.moveable-card:hover {
  -webkit-transform: scale(1.007, 1.007);
  transform: scale(1.007, 1.007);
}

.moveable-card:hover::after {
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.pagebreak {
  page-break-before: always;
}

.nopagebreak {
  page-break-after: avoid;
}
</style>
